'use strict';

export default class OPLFeaturedEvents {

    constructor() {
        this.carousels;
        this.upcomingEvents;
        this.classNameBase;
    }

    createFeaturedEventsCarousel(selector, requestOptions) {

        // if we dont have a selector or options
        // cancel the process
        if (!selector || !requestOptions) {
            return;
        }

        const _self = this;
        _self.carousels = document.querySelectorAll(selector);
        // remove the class/ID selector 
        _self.classNameBase = selector.replace(".", "").replace("#", "");

        if (_self.carousels.length > 0) {
            // get the events from the search index
            _self.upcomingEvents = _self.getFeaturedEvents(requestOptions, (data) => {
                // did the index return any values?
                if (data.value && data.value.length > 0) {
                    _self.renderFeaturedEvents(data.value);
                }
            });
        }


    }

    async getFeaturedEvents(_opts, _callback) {
        const _now = new Date();
        _now.setHours(0, 0, 0, 0);

        const _params = {
            top: 12,
            count: "true",
            search: "",
            filter: `EventGlobalFeatured eq true and EventPrivate eq false and EventModified eq 'not_modified' and EventStart ge ${_now.toISOString()} and (EventPublishDate eq null or EventPublishDate le ${_now.toISOString()})`, 
            orderby: "EventStart asc"
        }

        const _settings = {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "api-key": _opts.azureSearch.key,
                "Cache-Control": "no-cache",
            },
            body: JSON.stringify(_params)
        }

        await fetch(_opts.azureSearch.url, _settings)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json(); 
            })
            .then(data => {
                _callback(data); // Call the callback function and pass the data
            })
            .catch(error => {
                console.error(error); // Log any error
            })
    }

    renderFeaturedEvents(events) {       

        const _self = this;
        let eventList = '';

        // render the events list
        events.forEach(event => {

            const eventStart = new Date(event.EventStart);
            const eventStartDay = eventStart.getDate();
            const eventStartMonth = eventStart.toLocaleDateString('en-CA', { month: 'short' });            

            eventList += `<div class="${_self.classNameBase}-slide swiper-slide">
                            <a href="${event.url}" class="${_self.classNameBase}-item">
                                <div class="${_self.classNameBase}-item-date" aria-hidden="true">
                                    <div class="${_self.classNameBase}-item-date-day">${eventStartDay}</div>
                                    <div class="${_self.classNameBase}-item-date-month">${eventStartMonth}</div>
                                </div>
                                <div class="${_self.classNameBase}-item-body">
                                    <strong class="${_self.classNameBase}-item-title">${event.title}</strong>
                                    ${_self.getEventLocationText(event)}
                                    ${_self.getEventTimeText(event.EventStart, event.EventEnd) }
                                </div>
                            </a>
                        </div>`;
        });


        _self.carousels.forEach(carousel => {
            
            const innerWrapper = carousel.querySelector(`.${_self.classNameBase}-inner`);

            if (innerWrapper) {
                /// append the slides
                innerWrapper.innerHTML = eventList;

                const config = {
                    a11y: true,
                    centeredSlides: false,
                    clickable: false,
                    direction: "vertical",
                    grabCursor: true,
                    keyboard: true,
                    loop: false,
                    navigation: {
                        nextEl: carousel.parentElement.querySelector('.swiper-button-next'),
                        prevEl: carousel.parentElement.querySelector('.swiper-button-prev')
                    },
                    slidesPerView: 4
                };
                // init the swiper
                window.OPL.Swiper.initSwiper(carousel, config);
                // inform the SR that the list is ready
                innerWrapper.ariaBusy = false;
                // hide the loader
                const loader = carousel.querySelector('.opl-loader');
                if (loader) {
                    loader.style.display = "none";
                }
            }

        });

    }

    getEventLocationText(event) {
        const _self = this;
        let locationText = "";
        let locationTextHtml = "";
        if (event.EventLocationName && event.EventRoomName) {
            locationText = `${event.EventLocationName} - ${event.EventRoomName}`;
        }
        else if (event.EventLocationName) {
            locationText = event.EventLocationName;
        }
        else if (event.EventRoomName) {
            locationText = event.EventRoomName;
        }

        if (locationText != "") {
            locationTextHtml = `<div class="${_self.classNameBase}-item-location">
                                    <span class="fa-solid fa-location-dot" aria-hidden="true"></span>
                                    ${locationText}
                                </div>`
        }

        return locationTextHtml;
    }

    getEventTimeText(eventStart, eventEnd) {
        const _self = this;
        let eventTimeText = "";
        let eventTimeTextHtml = "";
        let _endTimeLabel = "";
        let _startTimeLabel = "";

        if (eventStart) {
            const _startDate = new Date(eventStart);
            const _startHoursPrim = _startDate.getHours();
            const _startMinsPrim = _startDate.getMinutes();
            const _startHours = _startHoursPrim > 12 ? _startHoursPrim - 12 : _startHoursPrim;
            const _startMin = _startMinsPrim < 10 ? '0' + _startMinsPrim : _startMinsPrim;
            _startTimeLabel = `${_startHours}:${_startMin} ${_startHoursPrim >= 12 ? 'pm' : 'am'}`;
        }

        if (eventEnd) {
            const _endDate = new Date(eventEnd);
            const _endHoursPrim = _endDate.getHours();
            const _endMinsPrim = _endDate.getMinutes();
            const _endHours = _endHoursPrim > 12 ? _endHoursPrim - 12 : _endHoursPrim;
            const _endMin = _endMinsPrim < 10 ? '0' + _endMinsPrim : _endMinsPrim;
            if (eventStart) {
                _endTimeLabel += ' - ';
            }
            _endTimeLabel += `${_endHours}:${_endMin} ${_endHoursPrim >= 12 ? 'pm' : 'am'}`
        }

        eventTimeText = _startTimeLabel + _endTimeLabel;

        if (eventTimeText != "") {
            eventTimeTextHtml = `<div class="${_self.classNameBase}-item-time">
                                    <span class="fa-regular fa-calendar" aria-hidden="true"></span>
                                    ${eventTimeText}
                                </div>`;
        }

        return eventTimeTextHtml;
    }

}
